export default __webpack_public_path__ + "static/media/banner-desktop.95830b2e.mp4";